<template>
  <img :src="`${publicPath}${src}`" />
</template>

<script>
export default {
  name: 'PublicPathImage',
  props: {
     src: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>
